import {
    FIRST_PAGE,
    PAGE_STEP,
    MAX_VISIBLE_PAGES_WITHOUT_ELLIPSIS,
    PAGINATION_EDGE_PAGE,
    PAGINATION_SIBLING_COUNT
} from '../cus-product-list.const';

export const buildPageWindow = (currentPage: number, totalPages: number): (number | 'ellipsis')[] => {
    if (totalPages <= MAX_VISIBLE_PAGES_WITHOUT_ELLIPSIS) {
        return Array.from({ length: totalPages }, (_, i) => i + FIRST_PAGE);
    }

    const delta = PAGINATION_SIBLING_COUNT;
    let left = currentPage - delta;
    let right = currentPage + delta;

    if (left < PAGINATION_EDGE_PAGE) {
        right += PAGINATION_EDGE_PAGE - left;
        left = PAGINATION_EDGE_PAGE;
    }
    if (right > totalPages - PAGE_STEP) {
        left -= right - (totalPages - PAGE_STEP);
        right = totalPages - PAGE_STEP;
    }

    left = Math.max(PAGINATION_EDGE_PAGE, left);
    right = Math.min(totalPages - PAGE_STEP, right);

    const pages: (number | 'ellipsis')[] = [];
    pages.push(FIRST_PAGE);
    if (left > PAGINATION_EDGE_PAGE) {
        pages.push('ellipsis');
    }
    for (let i = left; i <= right; i++) {
        pages.push(i);
    }
    if (right < totalPages - PAGE_STEP) {
        pages.push('ellipsis');
    }
    pages.push(totalPages);

    return pages;
};

export default function useProductListPagination({
    currentPage,
    totalPages,
    onPageChange
}: {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}) {
    const isFirstPage = currentPage <= FIRST_PAGE;
    const isLastPage = currentPage >= totalPages;

    const handlePage = (page: number) => {
        if (page < FIRST_PAGE || page > totalPages || page === currentPage) {
            return;
        }
        void onPageChange(page);
    };

    return {
        isFirstPage,
        isLastPage,
        handlePage
    };
}
